import React from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import heroContent from "./HeroContent";

import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import API_CONFIG from "../../config/api";


const courses = [
  {
    title: "Architecture & Interior Design",
    image: "Polymath-images/Artitecture Design/Rectangle 5.png",
    icon: "Polymath-images/Artitecture Design/Group 1686551982.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/architectureInteriorDesign"
  }

];

const ArchitecturePopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <>
      <Helmet>
        <title>Architecture & Interior Design Courses for Kids | Polymath-Kids</title>
        <meta name="description" content="Creative online architecture & interior design courses for kids! Learn space planning, adaptive reuse & design concepts through fun, skill-building lessons." />
      </Helmet>

      <div className="stem-container">
        <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
        <h1 className="stem-title">Architecture Courses</h1>
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.title} className="course-card">
              <Link to={course.link} className="course-link">

                <div className="course-image-container">
                  <img
                    src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                    alt={course.title}
                    className="course-image"
                  />
                  <span className="ages-badge">{course.age}</span>
                </div>

                <div className="icon-container" style={{ backgroundColor: course.color }}>
                  <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
                </div>

                <p className="course-title">{course.title}</p>
              </Link>
            </div>
          ))}
        </div>
        <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
          <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/pencil.png`} alt="icon" className="pobtn-icon" />
          Book Free Demo Class
        </button>
      </div>
    </>
  );
};
const ArchitecturePortal = () => {
  const architecturepage = heroContent.architecturepage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/architectureLeftImg.png"}
        rightImg={"Polymath-images/architectureRightImg.png"}
        titlePart1="Empowering Young Minds"
        titlePart2="With Architecture Courses"
        description="Interior architecture focuses more on structural design, with an emphasis on adaptive reuse and the remodelling of existing buildings. Whereas interior design is the practice of creating interior atmospheres - focusing on finishes, furniture and colour palettes."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={"Polymath-images/pencil.png"}
        button2Icon={"Polymath-images/pencil.png"}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <ArchitecturePopularCourses />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />

    </>
  );
};
export default ArchitecturePortal;
